// src/config/auth.ts
import { useAuthStore } from '@/stores/authStore';
import { redirectToClientLogin } from '@/auth/authRedirect';
// 1. 直接在這裡把 setUnauthorizedHandler 一併 import 進來
import api, { setUnauthorizedHandler } from '@/services/api';
export function setupUnauthorizedHandler() {
  const handleUnauthorized = () => {
    const authStore = useAuthStore();
    authStore.forceLogoutByApi();
    redirectToClientLogin();
  };

  // 2. 刪除原本的 require 行，直接呼叫剛剛 import 的函式
  setUnauthorizedHandler(handleUnauthorized);
}

export async function checkAuthStatus() {
  const authStore = useAuthStore();
  await authStore.checkAuthStatus();
}
